// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4af33422","453":"636d5082","455":"6de6336b"}[chunkId] + ".chunk.js";
};